/* eslint-disable */
import React from 'react';
import { HelpModalContentBody } from '@Components/HelpModal/HelpModal.style';
import { textblocks } from 'seal-ui-components';

const MarkupHelpModalContent = () => (
    <HelpModalContentBody>
        <textblocks.Heading3>Markup</textblocks.Heading3>

        <p>
            All analyzed text and any text identified as a risk can be highlighted with respective
            colors. Alternatively, the opposite can be identified with the "Unknown" option. When
            "Unknown" is selected, all text with risks identified appear grey, leaving all
            un-identified language in black.
        </p>

        <textblocks.Heading3>Warning</textblocks.Heading3>
        <p>
            Applying or clearing markup will overwrite any existing color formatting. If you need to
            preserve the color formatting, save your document and disable track changes before
            applying or clearing markup.
        </p>

        <textblocks.Heading3>Not Marked</textblocks.Heading3>
        <p>
            Short phrases with 3 or fewer words, ContractingParties, ContractClass, ContractType,
            WorkProcessName are all excluded from Markup.
        </p>

        <textblocks.Heading3>Track Changes</textblocks.Heading3>
        <p>
            The process to determine if track changes is enabled or not can add around 15 seconds to
            the processing time. This mechanism can be skipped, however, your tracked changes will
            be combined with the markup's updates to the document. If you wish to preserve your
            changes as part of your contract negotiation, disable track changes before applying or
            clearing the markup.
        </p>

        <textblocks.Heading3>Details</textblocks.Heading3>
        <p>
            Clicking a highlighted risk section will display information about Risk level, Topic,
            Subtopic, Question and Answer. All risks associated with the section are listed.
        </p>
    </HelpModalContentBody>
);

export default MarkupHelpModalContent;
